<script>
export let sad;
//import ContactItem from '../components/ContactItem.svelte';
</script>


<div class="contact-item">
      {sad.full_name}  <!--Заменить-->
</div>
    